import { Review, Submission } from '../model/paper';
import { SubmissionFilter } from '../model/submission.filter';

// Lista padrão de campos exibidos nas tabelas legacy (Lista de Submissões
// admin e show-all-submissions). Cards autor/revisor novos não usam.
export const DEFAULT_SUBMISSION_FIELDS = ['id', 'title', 'status', 'topics', 'authors', 'authors-names', 'authors-emails', 'authors-affiliations', 'submission-event', 'submission-track', 'rebuttal', 'discussion-messages', 'others-files', 'score-average'];

export interface SubmissionFieldsView {
  filter: SubmissionFilter;
  fieldsShow: string[];

  load(): void;
  filterPapers?(unfiltered: Array<Submission> | Array<Review>): void;
}
